export const fetchData = async () => {
    const fullUrl = `https://data.heroku.com/dataclips/iblndtabmtcusliurvdndcvhwlfj.json`;
    const response = await fetch(fullUrl);
    return await response.json();
};
